import { StringUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';

import { CellData } from '../models/cell-data';
import { ComponentData } from '../models/component-data';
import { TabData } from '../models/tab-data';
import { TableData } from '../models/table-data';

export class ComponentDataSelectorUtil {
	public static matchingTypeOptions = {
		String: 'string',
		StartWith: 'start',
		EndWith: 'end',
		Contain: 'contain'
	};

	public static tabSelector(componentData: ComponentData, tabIds: string[], matchingType: string = 'string'): TabData[] {
		let resultTabs: TabData[] = null;
		tabIds.forEach(id => {
			const selectedTabs = componentData.tabs.filter(tab => {
				switch (matchingType) {
					case ComponentDataSelectorUtil.matchingTypeOptions.StartWith:
						return StringUtil.testWithRegex(tab.config.id, '^' + StringUtil.convertStringForRegex(id));
					case ComponentDataSelectorUtil.matchingTypeOptions.EndWith:
						return StringUtil.testWithRegex(tab.config.id, StringUtil.convertStringForRegex(id) + '$');
					case ComponentDataSelectorUtil.matchingTypeOptions.Contain:
						return StringUtil.testWithRegex(tab.config.id, '\b' + StringUtil.convertStringForRegex(id) + '\b');
					case ComponentDataSelectorUtil.matchingTypeOptions.String:
					default:
						return tab.config.id === id;
				}
			});
			if (selectedTabs) {
				if (!resultTabs) { resultTabs = []; }
				resultTabs = resultTabs.concat(selectedTabs);
			}
		});
		return resultTabs;
	}
	public static cellFormattedValueSelector(table: TableData, headerXName: string, portfolioIndex: number): string {
		const desiredCell = ComponentDataSelectorUtil.cellSelector(table, headerXName, portfolioIndex);
		if (desiredCell) {
			const formattedValue: string = get(desiredCell, 'formattedValue');
			return formattedValue;
		}
		return null;
	}

	public static cellRawValueSelector(table: TableData, headerXName: string, portfolioIndex: number): string | number | any[] {
		const desiredCell = ComponentDataSelectorUtil.cellSelector(table, headerXName, portfolioIndex);
		if (desiredCell) {
			const rawValue = get(desiredCell, 'rawValue');
			return rawValue ? rawValue : 0;
		}
		return null;
	}
	public static cellSelector(table: TableData, headerXName: string, portfolioIndex: number): CellData {
		const headersX: CellData[] = get(table, 'headersX');
		if (table.cells && table.cells[portfolioIndex] && headersX) {
			const desiredValueIndex = headersX.findIndex(header => {
				return header.rawValue === headerXName;
			});
			if (desiredValueIndex !== -1) {
				const cell: CellData = get(table, `cells[${portfolioIndex}][${desiredValueIndex}]`);
				return cell;
			}
		}
		return null;
	}
	// add more like cell selector, table selector later
}
